<template>
  <div>
    <span class="sr-only">{{ getAriaText(params) }}</span>
    <c-function-button-menu
      :wid="parent.wid"
      :data="params.data"
      :disabledActions="disabledActions"
      :editLabel="params.editLabel"
      :accountId="params.accountId"
      :isFractional="params.isFractional"
      ref="dropdown"
      @edit="onEdit"
      @delete="onDelete"
      @editAlert="onEditAlert"
      v-if="!params.hide"
    />
  </div>
</template>

<script>
import CFunctionButtonMenu from '@custom/CFunctionButtonMenu';
import { getAriaText } from '@utils/helpers';
export default {
  components: {
    CFunctionButtonMenu
  },
  computed: {
    parent() {
      return this.params.context;
    },
    disabledActions() {
      return this.params.disabledActions ? this.params.disabledActions : ['delete', 'edit', 'editAlert'];
    }
  },
  created() {
    this.params.eGridCell.addEventListener('keydown', this.onKeyDown);
  },
  methods: {
    getAriaText,
    onEdit() {
      this.parent.onRowEdit(this.params.node);
    },
    onDelete() {
      this.parent.onRowDelete(this.params.node);
    },
    onEditAlert() {
      this.parent.onRowEditAlert(this.params.node);
    },
    onKeyDown(e) {
      const enter = e.keyCode === 13;
      const fwdTab = e.keyCode === 9 && !e.shiftKey;
      const buttonInFocus = e.target.tagName === 'BUTTON';
      if (!buttonInFocus && (fwdTab || enter)) {
        if (this.$refs.dropdown) this.$refs.dropdown.$el.querySelector('button').focus();
        e.preventDefault();
      } else if (buttonInFocus && e.keyCode === 27) {
        this.params.eGridCell.focus();
        e.preventDefault();
      }
    },
    refresh(params) {
      this.params = params;
      return true;
    }
  },
  beforeDestroy() {
    this.params.eGridCell.removeEventListener('keydown', this.onkeydown);
  }
};
</script>

<style lang="scss"></style>
